import { render, staticRenderFns } from "./custom-data-field.vue?vue&type=template&id=a2066138"
import script from "./custom-data-field.vue?vue&type=script&lang=js"
export * from "./custom-data-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports